import React from 'react';
import PropTypes from 'prop-types';

import IntroSlideSelect from './IntroSlideSelect';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const INTRO_SLIDE_SELECT_MODAL = 'modal/INTRO_SLIDE_SELECT';

const propTypes = {
  actionProps: PropTypes.shape({
    introImage: PropTypes.shape({
      id: PropTypes.string,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
        }),
      ),
    }),
  }),
};
const IntroSlideSelectModal = ({ actionProps, ...props }) => {
  return <IntroSlideSelect introImage={actionProps?.introImage} {...props} />;
};

IntroSlideSelectModal.propTypes = propTypes;

export default withModal(IntroSlideSelectModal, {
  name: INTRO_SLIDE_SELECT_MODAL,
  size: 'sm',
  type: 'full',
  contentLabel: <p className="w-100 text-center mb-0 h3">Cover slide</p>,
});
